<template>
  <div :class="['department-edit', {withoutMap: !geodata.length}]">
    <info-block :expand-mode="false">
      <div v-if="admin" class="department-edit__button">
        <router-link class="el-button el-button--default" :to="{ name: 'orgEdit', params: { id: orgId } }">
          <i class="el-icon-edit"></i>
          <span>{{ $t('orgs.subdivision_edit_short') }}</span>
        </router-link>
      </div>
    </info-block>
  </div>
</template>
<script>
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'
  import miniMap from './miniMap.vue'
  import {USER_ROLE_ADMIN} from '@/constants'

  export default {
    props: [
      'orgId',
      'geodata',
      'perms'
    ],
    components: {
      infoBlock,
      miniMap
    },
    methods: {
      showFullMap () {
        this.$emit('showFullMap')
      }
    },
    computed: {
      admin () {
        if (this.$store.state.user.user) {
          return this.$store.state.user.user.checkRole(USER_ROLE_ADMIN)
        }
        return false
      }
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';

.department-edit {
  text-align: center;

  &__button {
    margin: 30px -15px 0 -15px;
    .el-button {
      max-width: 100%;
      border-color: #e5e5e5;
      color: $secondary-font-color;

      &:hover {
        color: #409eff;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
    }
  }

  .dep-mini-map {
    &__map-container {
      margin: -15px -30px 0 -30px;
    }
  }

  .el-loading-mask {
    margin: 0 -30px;
  }

  &.withoutMap {
    .department-edit__button {
      margin-top: 0;
    }
  }
}
</style>